import { useExperiments } from '@wix/fe-essentials-standalone';
import { useContext, useState, useEffect } from 'react';

import { EXPERIMENTS } from '../constants';
import { Context } from '../context';
import { useWindowSize } from './useWindowSize';
import { isMobile, isTablet } from '../utils/user-agent';

const useIsAnswerGenerationMediaEnabled = () => {
  const context = useContext(Context);
  const [isMobileView, setIsMobileView] = useState(isMobile);
  const [isTabletView, setIsTabletView] = useState(isTablet);
  const { experiments } = useExperiments({ suspense: false, readOnly: true });
  const windowSize = useWindowSize();
  useEffect(() => {
    if (windowSize.width) {
      setIsMobileView(isMobile(context));
      setIsTabletView(isTablet(context));
    }
  }, [context, windowSize.width]);

  return (
    !isMobileView &&
    !isTabletView &&
    experiments.enabled(EXPERIMENTS.SPECS.ANSWER_GENERATION_MEDIA)
  );
};

export default useIsAnswerGenerationMediaEnabled;

